"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const logo_styled_1 = require("./logo.styled");
const logoUrl = require("./logo-emblem.svg");
exports.Logo = ({ url }) => {
    return React.createElement(logo_styled_1.default, { logoUrl: logoUrl },
        React.createElement("a", { className: "tn-logo", href: url || '/' },
            React.createElement("span", { className: "tn-logo__inner" }, "Home")));
};
//# sourceMappingURL=Logo.js.map